export const getCardPositionStyle = (verticalPosition, horizontalPosition, fullHeight) => {
  const baseStyle = {
    minHeight: fullHeight ? "100%" : "30%",
  };

  if (verticalPosition === "top") {
    if (horizontalPosition === "left") {
      Object.assign(baseStyle, {
        top: "0%",
        left: "0%",
        transform: "translate(0, 0)",
      });
    }
    if (horizontalPosition === "center") {
      Object.assign(baseStyle, {
        top: "0%",
        left: "50%",
        transform: "translate(-50%, 0)",
      });
    }
    if (horizontalPosition === "right") {
      Object.assign(baseStyle, {
        top: "0%",
        left: "100%",
        transform: "translate(-100%, 0)",
      });
    }
  } else if (verticalPosition === "middle") {
    if (horizontalPosition === "left") {
      Object.assign(baseStyle, {
        top: "50%",
        left: "0%",
        transform: "translate(0, -50%)",
      });
    }
    if (horizontalPosition === "center") {
      Object.assign(baseStyle, {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      });
    }
    if (horizontalPosition === "right") {
      Object.assign(baseStyle, {
        top: "50%",
        left: "100%",
        transform: "translate(-100%, -50%)",
      });
    }
  } else if (verticalPosition === "bottom") {
    if (horizontalPosition === "left") {
      Object.assign(baseStyle, {
        top: "100%",
        left: "0%",
        transform: "translate(0, -100%)",
      });
    }
    if (horizontalPosition === "center") {
      Object.assign(baseStyle, {
        top: "100%",
        left: "50%",
        transform: "translate(-50%, -100%)",
      });
    }
    if (horizontalPosition === "right") {
      Object.assign(baseStyle, {
        top: "100%",
        left: "100%",
        transform: "translate(-100%, -100%)",
      });
    }
  }
  return baseStyle;
};
